import { UiKitTagToggle } from '@/fo/ui/kit/tag/toggle';

import { FilterOption } from '../../../types';
import { FilterComponentProps } from '../types';

import { styles } from './ToggleListFilter.styles';

/** Компонент для отображения toggle фильтров */
export function ToggleListFilter({
  options,
  selected,
  onChange
}: FilterComponentProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      {(options as FilterOption[]).map((option) => {
        const isSelected =
          Array.isArray(selected) &&
          selected.some((value) => value === option.value);

        return (
          <UiKitTagToggle
            key={option.value}
            selected={isSelected}
            onChange={(checked) => onChange(option.value, checked)}
          >
            {option.label}
          </UiKitTagToggle>
        );
      })}
    </div>
  );
}
